import { SignUp } from '../components/Authentication/SignUp/SignUp'

export const SignUpPage = () => {
    return <SignUp />
}
